/**
 * The "Generic document" pseudo-template (Noteble's __generic__ option).
 *
 * Not a real tenant template: selecting it sends the captured content to the
 * assembly job with no template scaffold, and the AI shapes it into the most
 * suitable document. Created as a requirement (the type the old "Draft with
 * AI" toggle produced).
 */

import type { TemplateMetadata } from '@/services/templatesApi';

export const GENERIC_TEMPLATE_ID = '__generic__';

export const GENERIC_TEMPLATE: TemplateMetadata = {
  id: GENERIC_TEMPLATE_ID,
  name: 'Generic document',
  description: 'No template — AI shapes your captured content into the most suitable document.',
  docType: 'requirement',
  icon: 'Sparkles',
  color: 'violet',
  type: 'platform',
};

export const isGenericTemplate = (id: string) => id === GENERIC_TEMPLATE_ID;
